// removed by extract-text-webpack-plugin
module.exports = {"clients":"_3Lho","client":"_2X5R","clientTitle":"_2_Oj","wrapper":"_3245","clientLink":"_2TMo","logo":"_2r8H","primaryColor":"_1diY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Clients/styles.scss
// module id = 393
// module chunks = 0